/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/percentagebar/horizontal/horizontal_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:true});



/* ========== ~~~~~~~~~~ PERCENTAGE BAR : HORIZONTAL ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class HorizontalBar extends Component {

	/* <<<<<<<<<< LIFECYCLE FUNCTIONS >>>>>>>>>> */
	constructor(props) {
		super(props);
        this.barCoefficient = 1; // this.props.barCoefficient === undefined ? 1 : 0.8 * this.props.barCoefficient;
        this._interval = null; // needs to be component level to clear it later on dismount
		this.state = {
			percent: 0,
			finished: false,
			endSize: '0%'
		}
	}
	componentDidMount() {
		this.animateBar();
		setTimeout(() => {
			this.setState({ endSize: `${this.barCoefficient * this.props.amount}%` });
		},10);
	}
	componentWillUnmount() {
		this.resetBar();
	}

	/* >>>>>>>>>> CUSTOM FUNCTIONS <<<<<<<<<< */
	animateBar() {
		let localPercent = 1;
	    this._interval = setInterval(() => {
	        if (localPercent >= this.props.amount) {
	            clearInterval(this._interval);
	            this.setState({
	            	finished: true
	            });
	        } else {
	        	localPercent++;
	        	// sheet.getRule('foreground').prop('width', `${localPercent}%`); // update stylesheet with ever changing height
	            this.setState({
	            	percent: localPercent
	            });
	        }
	    }, 10);
	}
	resetBar() {
		// make sure this is also called from unmount
		clearInterval(this._interval); // clear interval
	    sheet.getRule('foreground').prop('width', `0%`); // reset to 0 for next animation
	}

	/* /////////////// RENDER \\\\\\\\\\\\\\\ */
	render() {
	    return(
	    	<span className={`${sheet.classes.inner} selected-${this.props.isClicked} correct-${this.props.isCorrectAnswer} finished-${this.state.finished}`}>
	        	<span className={`${sheet.classes.bar} bar ${sheet.classes.foreground} foreground`} style={{width: `${this.state.endSize}`}}></span>
	        	<span className={`${sheet.classes.bar} bar ${sheet.classes.background} background`}></span>
	        	<span className={`${sheet.classes.number} number`}>{`${this.state.percent}%`}</span>
		    </span>
	    );
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default HorizontalBar;
